/**
 * 活动主视图渲染逻辑
 */
import customEvent from 'mihoyo-custom-event';
import model from '../models/default';
import BScroll from 'better-scroll';
import tpl from './rep.tpl';

// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {
  /**
   * 统一的渲染入口，方法名固定，不要更改
   */
  render() {
    if (!this.isPC()) {
      window.location.href = 'https://webstatic.mihoyo.com/bh3/event/e20190219bh3v3mobile/index.html';
    }
    this.init();
    this.events();
  },

  window() {
    return $(window);
  },

  navbars() {
    return $('.navbar-selects,.navbar');
  },

  repList() {
    return $('.repwrapper');
  },

  progress() {
    return $('.progress');
  },

  temperature() {
    return $('.temperature');
  },

  canAnime: true,

  canScroll: true,

  start: 0,
  
  end: 20,

  /**
   * 视图事件集中绑定
   */
  events() {
    const bscroll = new BScroll('.replist', {
      pullUpLoad: {
        threshold: 0
      }
    });
    const refreshBS = () => {
      setTimeout(function(){
        bscroll.refresh();
      }, 0);
    };
    bscroll.on('pullingUp', () => {
      model.getRepList({
        data: {
          last_id: this.start,
          size: 20
        }
      }).then((data) => {
        this.start = data.last_id;
        this.repList().append(template.render(tpl, data.list));
        bscroll.finishPullUp();
        refreshBS();
      });
    });
    const scrollAnime = o => {
      const fontsize = parseFloat($('html').css('font-size'));
      this.canAnime = false;
      $("html,body").animate({"scrollTop":o / 100 * fontsize}, 500, () => {
        this.canAnime = true;
      })
    };
    const changeNavbar = o => {
      this.navbars().fadeIn();
      this.changeSwiperActive($(`.navbar-select[data-id='${o}']`)[0], '.navbar-select');
    }
    this.window().on('scroll', (e) => {
      const fontsize = parseFloat($('html').css('font-size'));
      if (this.canScroll) {
        const val = this.window().scrollTop();
        const scrollCheck = (left, right) => this.canAnime && val > left / 100 * fontsize && val < right / 100 * fontsize;
        if (scrollCheck(400, 600)) {
          changeNavbar(1);
          scrollAnime(1080);
        } else if (scrollCheck(780, 1050)) {
          this.navbars().fadeOut();
          scrollAnime(0);
        } else if (scrollCheck(1279, 1580)) {
          changeNavbar(2);
          scrollAnime(2160);
        } else if (scrollCheck(1660, 1961)) {
          changeNavbar(1);
          scrollAnime(1080);
        } else if (scrollCheck(2359, 2660)) {
          changeNavbar(3);
          scrollAnime(3240);
        } else if (scrollCheck(2840, 3141)) {
          changeNavbar(2);
          scrollAnime(2160);
        } else if (scrollCheck(3439, 3740)) {
          changeNavbar(4);
          scrollAnime(4320);
        } else if (scrollCheck(3820, 4121)) {
          changeNavbar(3);
          scrollAnime(3240);
        } else if (scrollCheck(4519, 4820)) {
          changeNavbar(5);
          scrollAnime(5400);
        } else if (scrollCheck(4920, 5221)) {
          changeNavbar(4);
          scrollAnime(4320);
        } else if (scrollCheck(5499, 5800)) {
          changeNavbar(6);
          scrollAnime(6400);
        } else if (scrollCheck(5900, 6201)) {
          changeNavbar(5);
          scrollAnime(5400);
        }
      }
    });
    setTimeout(() => {
      this.swiper1 = new window.Swiper('.swiper1', {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }
      });
      $('.carosel1-next').click(() => {
        this.swiper1.slideNext();
      });
      $('.carosel1-prev').click(() => {
        this.swiper1.slidePrev();
      });
      this.swiper2 = new window.Swiper('.swiper2', {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }
      });
      $('.carosel2-next').click(() => {
        this.swiper2.slideNext();
      });
      $('.carosel2-prev').click(() => {
        this.swiper2.slidePrev();
      });
      this.swiper3 = new window.Swiper('.swiper3', {
        slidesPerView: 1,
        direction: 'vertical',
        centeredSlides: true,
        on:{
          slideChange: () => {
            this.changeSwiperActive($(`.swiperBtn3[data-id='${this.swiper3.activeIndex + 1}']`)[0], '.swiperBtn3');
          },
        },
      });
      $('.swiperBtn1').click((e) => {
        this.swiper1.slideTo(e.target.dataset.id, 1000, false);
      });
      $('.swiperBtn3').click((e) => {
        this.changeSwiperActive(e.target);
        this.swiper3.slideTo(e.target.dataset.id - 1, 1000, false);
      });
    }, 0);
    $('.navbar-select').click((e) => {
      switch (e.target.dataset.id) {
        case '1':
          scrollAnime(1080);
          break;
        case '2':
          scrollAnime(2160);
          break;
        case '3':
          scrollAnime(3240);
          break;
        case '4':
          scrollAnime(4320);
          break;
        case '5':
          scrollAnime(5400);
          break;
        case '6':
          scrollAnime(6400);
          break;
        case '0':
          this.navbars().fadeOut();
          scrollAnime(0);
          break;
        default:
          break;
      }
      this.changeSwiperActive(e.target, '.navbar-select');
    });
    $('.rule-btn').click(() => {
      this.modal('.rule-modal');
    });
    $('.award-btn').click(() => {
      this.modal('.award-modal');
    });
    $('.shareBtn').click(() => {
      this.modal('.share-modal', 'PC端用户请识别二维码前往手机端进行分享操作分享成功还有60水晶的奖励哟！（成功后可在页面-奖品查看）');
    });
    $('.rep-btn').click(() => {
      window.open('https://bbs.mihoyo.com/bh3/#/article/28798', '_blank');
    });
    $(document).ready(() => {
      if(this.window().scrollTop() > 200) {
        if (this.window().scrollTop() >= 6400) {
          changeNavbar(6);
        } else {
          changeNavbar(parseInt(this.window().scrollTop()/1080, 10));
        }
        this.navbars().fadeIn();
      }
    });
  },

  changeSwiperActive(ele, eles) {
    $(eles).attr('data-active', 'unactive');
    ele.dataset.active = 'active';
  },

  getCookie(cname)
  {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++) 
    {
      const c = ca[i].trim();
      if (c.indexOf(name)==0) return `?${cname}=${c.substring(name.length,c.length)}`;
    }
    return '';
  },

  isPC()
  {
    const userAgentInfo = navigator.userAgent;
    const Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    let flag = true;
    Agents.forEach((item) => {
      if (userAgentInfo.indexOf(item) !== -1) {
        flag = false;
      }
    });
    return flag;
  },

  init() {
    if (window.location.href.indexOf('login_ticket') !== -1){
      model.getCookieToken();
    }
    template.defaults.escape = false;
    model.init().then(({temperature, is_reply, user_code}) => {
      this.temperature().html(temperature);
      if (temperature >= 200000 && temperature < 1000000) {
        this.progress().attr('data-id', 2);
        this.temperature().attr('data-id', 2);
      } else if (temperature >= 1000000 && temperature < 2000000) {
        this.progress().attr('data-id', 3);
        this.temperature().attr('data-id', 3);
      } else if (temperature >= 2000000 && temperature < 3000000) {
        this.progress().attr('data-id', 4);
        this.temperature().attr('data-id', 4);
      } else if (temperature >= 3000000) {
        this.progress().attr('data-id', 5);
        this.temperature().attr('data-id', 5);
      } else {
        this.progress().attr('data-id', 1);
        this.temperature().attr('data-id', 1);
      }
      if (is_reply) {
        this.modal('.basic-modal', '回复成功！热度+1');
      }
      if (user_code) {
        $('.award-code>.content').html(user_code);
        $('.award-code').fadeIn(0);
      }
      new window.QRCode(document.getElementById("qrcode"),
        `https://webstatic.mihoyo.com/bh3/event/e20190219bh3v3mobile/index.html${this.getCookie('login_ticket')}`);
    }).fail(({msg}) => {
      this.modal('.basic-modal', msg);
    });
    model.getRepList({
      data: {
        last_id: this.start,
        size: 20
      }
    }).then((data) => {
      this.start = data.last_id;
      this.repList().append(template.render(tpl, data.list));
    });
  },
  modal(container,msg,onSuccess,onCancel){
    $('body').css('overflow','hidden');
    document.addEventListener('touchmove', preHandler,false);
    const preHandler = (e) => {
      e.preventDefault();
    }
    $('.modal-info').html(msg);
    $('.modal-cancel').off("click").on("click",function(){
      $(container).css('display','none');
      $('body').css('overflow','auto');
      document.removeEventListener('touchmove', preHandler, false);
      if(typeof(onCancel) === 'function'){
        onCancel();
      }
    })
    $('.modal-ok').off("click").on("click",function(){
      $(container).css('display','none');
      $('body').css('overflow','auto');
      document.removeEventListener('touchmove', preHandler, false);
      if(typeof(onSuccess) === 'function'){
        onSuccess();
      }
    })
    $(container).css('display','block');
    
  }
}


